import { render, staticRenderFns } from "./aboutContents.vue?vue&type=template&id=32d54484&scoped=true&"
import script from "./aboutContents.vue?vue&type=script&lang=js&"
export * from "./aboutContents.vue?vue&type=script&lang=js&"
import style0 from "./aboutContents.vue?vue&type=style&index=0&id=32d54484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d54484",
  null
  
)

component.options.__file = "aboutContents.vue"
export default component.exports